import { useAesCrypto } from 'use-crypto';

function useMapper() {
  const { decrypt } = useAesCrypto("&Rw!mx[[s9'L1I-xP<pkHFv4@:O?2g");

  const mapUser = (user) => {
    return user;
  };

  const mapEnquiry = (enquiry) => {
    return enquiry;
  };

  const mapFeedback = (feedback) => {
    return feedback;
  };

  const mapHomeUser = (homeUser) => {
    return homeUser;
  };

  const mapCompanyUser = (user) => ({
    ...user,
    contact: {
      ...user?.contact,
      emailAddress: decrypt(user?.contact?.emailAddress ?? ''),
    },
    details: {
      ...user?.details,
      companyName: decrypt(user?.details?.companyName ?? ''),
      firstName: decrypt(user?.details?.firstName ?? ''),
      lastName: decrypt(user?.details?.lastName ?? ''),
      jobTitle: decrypt(user?.details?.jobTitle ?? ''),
      location: decrypt(user?.details?.location ?? ''),
    },
  });

  const mapCompany = (company) => ({
    ...company,
    details: {
      ...company?.details,
      regNumber: decrypt(company?.details?.regNumber ?? ''),
      taxNumber: decrypt(company?.details?.taxNumber ?? ''),
    },
  });

  return { mapUser, mapCompany, mapCompanyUser, mapFeedback, mapEnquiry, mapHomeUser };
}

export default useMapper;
